import { type ColumnDef } from "@tanstack/react-table";
import type { TFunction } from "i18next";
import { ArrowUpDown } from "lucide-react";
import { formatSuccessRate } from "@/utils/success-rate";
import type { ApiSuccessRatePerTopicStat } from "../types";

const sortableHeader =
  (label: string) =>
  ({
    column,
  }: {
    column: {
      toggleSorting: (desc?: boolean) => void;
      getIsSorted: () => false | "asc" | "desc";
    };
  }) => (
    <button
      onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      className="flex items-center gap-1 cursor-pointer"
    >
      {label}
      <ArrowUpDown
        className={`ml-1 size-4 ${column.getIsSorted() ? "text-primary" : "opacity-50"}`}
      />
    </button>
  );

export const successRatePerTopicColumns = (
  t: TFunction,
): ColumnDef<ApiSuccessRatePerTopicStat>[] => [
  {
    accessorKey: "topic_name",
    header: t("modules.stats.part2.columns.topic"),
    cell: ({ row }) => (
      <span className="font-medium">{row.getValue("topic_name")}</span>
    ),
  },
  {
    accessorKey: "success_rate",
    header: sortableHeader(t("modules.stats.part2.columns.success_rate")),
    cell: ({ row }) => (
      <span>
        {formatSuccessRate(row.getValue<number | null>("success_rate"))}
      </span>
    ),
  },
  {
    accessorKey: "resolved_count",
    header: sortableHeader(t("modules.stats.part2.columns.resolved_count")),
    cell: ({ row }) => (
      <span className="text-gray-600">{row.getValue("resolved_count")}</span>
    ),
  },
];
